export var IdBalloonOfferTypes;
(function (IdBalloonOfferTypes) {
    IdBalloonOfferTypes[IdBalloonOfferTypes["Free"] = 1] = "Free";
    IdBalloonOfferTypes[IdBalloonOfferTypes["Pay"] = 2] = "Pay";
    IdBalloonOfferTypes[IdBalloonOfferTypes["Ad"] = 3] = "Ad";
    IdBalloonOfferTypes[IdBalloonOfferTypes["FreeAndAd"] = 4] = "FreeAndAd";
})(IdBalloonOfferTypes || (IdBalloonOfferTypes = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdBalloonOfferTypes.ts
// module id = 560
// module chunks = 3